export const baseStyles = (titleText = '') => `
<!DOCTYPE html>
<html>
<head>
  <meta charset="utf-8">
  <meta http-equiv="X-UA-Compatible" content="IE=edge" />
  <meta name="viewport" content="width=device-width, initial-scale=1" />
  <style>
    body { margin: 0; padding: 24px; font-size: 12px; line-height: 1.45; font-family: 'Nikosh','NikoshBAN','SolaimanLipi', Arial, Helvetica, sans-serif; }
    .header { text-align: center; margin-bottom: 16px; }
    .logo { width: 90px; height: 90px; margin: 0 auto 8px; border-radius: 50%; overflow: hidden; display: flex; align-items: center; justify-content: center; }
    .logo img { width: 100%; height: 100%; object-fit: contain; }
    .title { font-weight: 700; margin: 4px 0; }
    .sub { margin: 2px 0; }
    .section-title { font-weight: 600; border-bottom: 1px solid #000; padding-bottom: 4px; margin: 16px 0 8px; }
    table { width: 100%; border-collapse: collapse; }
    th, td { border: 1px solid #000; padding: 6px 8px; vertical-align: top; }
    th { background: #f5f5f5; font-weight: 600; }
    .label { width: 28%; font-weight: 600; }
    .value { width: 72%; }
    .no-border td { border: none; padding: 0; }
    .left { text-align: left; }
    @media print { body { -webkit-print-color-adjust: exact; print-color-adjust: exact; } }
  </style>
</head>
<body>
  <div class="header">

    <div class="title">কেস ম্যানেজমেন্ট সিস্টেম,</div>
    <div class="sub">বাংলাদেশ সেতু কর্তৃপক্ষ, ঢাকা</div>
    <div class="sub">সরকারি স্বার্থসংক্রান্ত আদালতের মামলাসমূহ</div>
    ${titleText ? `<div class="section-title" style="border:none;margin-top:10px;">${titleText}</div>` : ''}
  </div>
  __CONTENT__
</body>
</html>`;

function logoMarkup(logoUrl) {
    if (!logoUrl) return '';
    return `<img src="${logoUrl}" alt="logo" />`;
}

// Convert English digits in a string to Bangla digits
function toBnDigits(input) {
    if (input === null || input === undefined) return '';
    const map = { '0': '০', '1': '১', '2': '২', '3': '৩', '4': '৪', '5': '৫', '6': '৬', '7': '৭', '8': '৮', '9': '৯' };
    return String(input).replace(/[0-9]/g, d => map[d] || d);
}

export function generateDistrictSingleHtml(data, logoUrl) {
    const d = data?.result1 || {};
    const plaintiffs = data?.result2 || [];
    const defendants = data?.result3 || [];
    const officers = data?.result4 || [];
    const hearings = data?.result5 || [];

    const content = `
  <div>
    <div class="section-title">বিস্তারিত তথ্য</div>
    <table>
      <tbody>
        <tr><td class="label">মামলার জেলা</td><td class="value left">${d.district_name || ''}</td></tr>
        <tr><td class="label">আদালতের নাম</td><td class="value left">${d.court_type_name || ''}</td></tr>
        <tr><td class="label">মামলার ক্যাটেগরি</td><td class="value left">${d.category_name || ''}</td></tr>
        <tr><td class="label">মামলার শ্রেণী/কেস-টাইপ</td><td class="value left">${d.case_type_name || ''}</td></tr>
        <tr><td class="label">মামলা নং</td><td class="value left">${d.case_number || ''}</td></tr>
        <tr><td class="label">মামলা দায়েরের তারিখ</td><td class="value left">${toBnDigits(d.filing_date || '')}</td></tr>
        <tr><td class="label">বিষয়বস্তু(সংক্ষিপ্ত)</td><td class="value left">${d.case_description || ''}</td></tr>
        <tr><td class="label">ফলাফল</td><td class="value left">${d.case_status == 1 ? 'মামলা চলমান' : 'নিষ্পত্তিকৃত মামলা'}</td></tr>
      </tbody>
    </table>

    <div class="section-title">বাদীর বিবরণ</div>
    <table>
      <thead><tr><th style="width:60px">ক্রম</th><th>নাম,মোবাইল নং ,ঠিকানা</th></tr></thead>
      <tbody>
        ${plaintiffs.map((p, i) => `<tr><td>${i + 1}</td><td class="left">${p.plaintiff_name || ''}${p.plaintiff_mobile ? ',' + toBnDigits(p.plaintiff_mobile) : ''}${p.plaintiff_address ? ',' + p.plaintiff_address : ''}</td></tr>`).join('')}
      </tbody>
    </table>

    <div class="section-title">বিবাদীর বিবরণ</div>
    <table>
      <thead><tr><th style="width:60px">ক্রম</th><th>নাম,মোবাইল নং ,ঠিকানা</th></tr></thead>
      <tbody>
        ${defendants.map((p, i) => `<tr><td>${i + 1}</td><td class="left">${p.defendant_name || ''}${p.contact_no ? ',' + toBnDigits(p.contact_no) : ''}${p.address ? ',' + p.address : ''}</td></tr>`).join('')}
      </tbody>
    </table>

    <div class="section-title">সংশ্লিষ্ট আইন কর্মকর্তার বিবরণ</div>
    <table>
      <thead><tr><th style="width:60px">ক্রম</th><th style="width:220px">আইন কর্মকর্তা</th><th>নাম,মোবাইল নং ,ঠিকানা</th></tr></thead>
      <tbody>
        ${officers.map((p, i) => `<tr><td>${i + 1}</td><td class="left">${p.law_officer_name || ''}</td><td class="left">${p.officer_name || ''}${p.officer_mobile ? ',' + p.officer_mobile : ''}${p.officer_address ? ',' + p.officer_address : ''}</td></tr>`).join('')}
      </tbody>
    </table>

    <div class="section-title">শুনানি তারিখ এবং বিবরণ</div>
    <table>
      <thead><tr><th style="width:60px">ক্রম</th><th>সর্বশেষ শুনানির তারিখ</th><th>পরবর্তী শুনানির তারিখ</th><th>মন্তব্য (সংক্ষিপ্ত)</th></tr></thead>
      <tbody>
        ${hearings.map((p, i) => `<tr><td>${i + 1}</td><td>${toBnDigits(p.hearing_date || '')}</td><td>${toBnDigits(p.next_hearing_date || '')}</td><td class="left">${p.hearing_notes || ''}</td></tr>`).join('')}
      </tbody>
    </table>
  </div>`;

    return baseStyles('বিস্তারিত তথ্য').replace('__LOGO__', logoMarkup(logoUrl)).replace('__CONTENT__', content);
}

export function generateHighSingleHtml(data, logoUrl) {
    // Fields are almost same for High Court single
    return generateDistrictSingleHtml(data, logoUrl);
}

export function generateAppealSingleHtml(data, logoUrl) {
    // Appeal adds a couple of labels (appelier/petitioner_name) if present
    const d = data?.result1 || {};
    const html = generateDistrictSingleHtml(data, logoUrl);
    const insertion = `<tr><td class="label">আপিলকারী</td><td class="value left">${d.appelier || ''}</td></tr>
  <tr><td class="label">পিটিশনারের নাম</td><td class="value left">${d.petitioner_name || ''}</td></tr>`;
    return html.replace('<tr><td class="label">মামলা নং', insertion + '<tr><td class="label">মামলা নং');
}


